"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  appointmentHistory: {
    inVvl: 'IN VVL',
    outVvl: 'OUT VVL',
    blNo: 'B/L No',
    appointment: 'Appointment',
    appointmentNotNull: '预约时间不能为空',
    vesselAndVoyageNotNull: '船名&航次不能为空',
    notSamePort: 'Please check the same port',
    notBatchPrint: 'Non CNTAO and CNSHK do not support batch printing',
    searchNotNull: 'IN VVL/OUT VVL/B/L No./Appointment From/To One of the terms cannot be empty',
    notBookedCannotCancel: 'Cannot cancel the booking if it was not booked.',
    cantPrint: 'EDO code is empty , so can not print!',
    alreadyExchangedCannotUpdatePickDate: '已换单不能再更改提箱日期'
  },
  appointmentHistoryTable: {
    outVesselCode: 'Out Vessel Code',
    outVoyageNo: 'Out Voyage No',
    outVoyageLeg: 'Out Voyage Leg',
    inVesselCode: 'In Vessel Code',
    inVoyageNo: 'In Voyage No',
    inVoyageLeg: 'In Voyage Leg',
    blNo: 'Bl No',
    pod: 'POD',
    deliverableDate: 'Delivarable Date',
    eta: 'Eta',
    invoiceTitle: 'Invoice Title',
    paymentStatus: 'Payment Status',
    edoSentStatus: 'Edo Sent Status',
    forespeakStatus: 'Appoint Status',
    forespeakDate: 'Appoint Date',
    updatePickCtnDate: 'Update Date',
    attachmentAudit: 'Attachment approve',
    deliveryReleaseFlag: 'Delivery Release Flag',
    edoCertifyCode: 'EDO Certify Code',
    anCode: 'AN Code',
    print: 'Print',
    paymentDate: 'Payment Date',
    edoSentStatusSh: 'Edo Sent Status',
    accreditSentStatus: 'Accredit Sent Status',
    accreditStatus: 'Accredit Status',
    printDO: 'DO',
    printBill: 'Bill',
    printVoyage: 'Voyage',
    forespeakNo: 'Appoint No',
    dem: 'DEM',
    foreSpeakInfo: 'Appoint Info',
    downloadFile4AN: 'AN Download',
    downloadFile4Invoice: 'INVOICE Download'
  }
};